import { ZonePolicyDueDateType } from '@/types'
import { createFileRoute } from '@tanstack/react-router'

import { CredenzaBody, CredenzaContent } from '@/components/ui/credenza'
import EditZonesPolicyForm from '@/components/forms/edit-zones-policy-due-date-form'

export const Route = createFileRoute(
  '/_home/zone-settings/zone-policy-due-date/edit',
)({
  component: EditZonePolicyPage,
})

export default function EditZonePolicyPage({
  zonePolicyData,
  setShowEditModal,
}: {
  zonePolicyData: ZonePolicyDueDateType
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      <CredenzaContent className="overflow-auto md:max-h-[600px] md:max-w-[750px]">
        <CredenzaBody className="max-h-full max-w-full">
          <EditZonesPolicyForm
            zonePolicyData={zonePolicyData}
            setShowEditModal={setShowEditModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
